export default __webpack_public_path__ + "static/nft4-f49a0c29f2a03881e8b58cce78428bb3.png";